<template>
  <div class="detail">
    <div class="baseInfo">
      <div class="imgWrapper">
        <div class="showImg">
          <img v-lazy="currentImg" alt="">
        </div>
        <div class="imgList">
          <div class="prev" @click="scrollList('prev')"><i class="el-icon-caret-left"></i></div>
          <div class="listWrapper">
            <div class="list">
              <div v-for="img in imgList"
                   :class="{activeImg:img.id === currentImgId ? true : false}"
                   @click="showImg(img)"
                   :key="img.id">
                <img v-lazy="'http://file.hoaccu.com/' + img.img" :alt="img.img">
              </div>
            </div>
          </div>
          <div class="next" @click="scrollList('next')"><i class="el-icon-caret-right"></i></div>
        </div>
      </div>
      <div class="desc" v-loading="loading" element-loading-text="拼命加载中"
           element-loading-spinner="el-icon-loading"
           element-loading-background="#eee" v-html="content"></div>
    </div>
    <div class="params" v-html="params"></div>
  </div>
</template>
<script>
  import {
    getSparePartInfo,
    getProductImg
  } from "@/api/hoaccu";

  export default {
    name: "detail",
    data() {
      return {
        content: "",
        params: "",
        loading: false,
        imgList: [],
        currentImg: "",
        currentImgId: "",
      }
    },
    created() {
      this.getInfo();
    },
    methods: {
      getInfo() {
        this.loading = true;
        getSparePartInfo({
          page: 1,
          pageSize: 1,
          condition: [
            {
              "key": "id",
              "value": this.$route.params.id
            }
          ]
        }).then(res => {
          if (res.status === 200) {
            if (res.data.data.length) {
              this.content = res.data.data[0].productDesc;
              this.params = res.data.data[0].parameter;
              if (this.params.indexOf("<img") !== -1) {
                this.params = this.params.split("<img").join("<img style='max-width: 920px;'");
              }
              getProductImg({
                page: 1,
                pageSize: 100000,
                condition: [
                  {
                    key: "spareId",
                    value: res.data.data[0].id
                  }
                ]
              }).then(response => {
                this.imgList = response.data.data;
                this.currentImg = 'http://file.hoaccu.com/' + (this.imgList.length ? this.imgList[0].img:null);
                this.currentImgId = (this.imgList.length ? this.imgList[0].id:null);
              })
              this.loading = false;
            } else {
              this.content = "暂无数据";
              this.loading = false;
            }
          } else {
            this.$message.warning(res.message);
            this.loading = false;
          }
        }).catch(err => {
          this.$message.warning(err.message);
          this.loading = false;
        })
      },
      showImg(img) {
        this.currentImg = 'http://file.hoaccu.com/' + img.img;
        this.currentImgId = img.id;
      },
      scrollList(dicrection) {
        let dom = document.querySelector('.list');
        let num = 2;
        let sumWidth = num * 80;
        let disWidth = dom.clientWidth - 350;
        let startLeft = dom.style.left.split('px')[0];
        let interval = setInterval(() => {
          if (dicrection === "next") {
            if (dom.style.left.split('px')[0] <= -disWidth) {
              clearInterval(interval)
            } else {
              dom.style.left = +dom.style.left.split('px')[0] - 5 + "px";
            }
          } else {
            if (+dom.style.left.split('px')[0] >= 0) {
              clearInterval(interval)
            } else {
              dom.style.left = +dom.style.left.split('px')[0] + 5 + "px";
            }
          }
          if (Math.abs(dom.style.left.split('px')[0] - startLeft) >= sumWidth) {
            clearInterval(interval)
          }
        }, 1)
      }
    },
  }
</script>
<style lang="less" scoped>
  .detail {
    padding: 10px 0;

    .baseInfo {
      display: flex;

      .imgWrapper {
        width: 450px;

        .showImg {
          width: 400px;
          height: 300px;
          overflow: hidden;
          border: 1px solid #ccc;
          display: flex;
          align-items: center;
          background: #fff;

          img {
            width: 398px;
            /*height: 298px;*/
          }
        }

        .imgList {
          width: 400px;
          height: 75px;
          display: flex;
          justify-content: space-between;

          .prev, .next {
            width: 15px;
            height: 60px;
            background: #efe;
            border-radius: 5px;
            border: 1px solid #ddd;
            cursor: pointer;
            text-align: center;
            line-height: 60px;
            margin-top: 10px;
          }

          .listWrapper {
            position: relative;
            width: 350px;
            margin-top: 5px;
            margin-left: -5px;
            overflow: hidden;

            .list {
              position: absolute;
              left: 0;
              top: 0;
              display: flex;
              overflow: hidden;

              & > div {
                margin: 0 5px;
                cursor: pointer;
                width: 70px;
                height: 70px;
                box-sizing: border-box;
                border: 1px solid #fff;
                background: #fff;
                display: flex;
                overflow: hidden;

                img {
                  margin-left: 50%;
                  transform: translateX(-50%);
                  align-items: center;
                  width: 68px;
                }
              }

              .activeImg {
                border: 1px solid red;
                overflow: hidden;
              }
            }
          }
        }
      }

      .desc {
        width: 470px;
      }
    }

    .params {
      margin-top: 20px;
      width: 920px;
      overflow: hidden;
    }
  }
</style>
